import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map, pluck } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CreatePageFormService {

  constructor(private http: HttpClient) { }

  getCountryList() {
    return this.http.get(`/vd/countries`).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
  }

  getModuleList() {
    return this.http.get('/vd/formBuilder/module/list').pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getBuildFormatList() {
    return this.http.get('/vd/formBuilder/buildFormat/list').pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getBuildFormatTypeList(buildFormatId) {
    return this.http.get(`/vd/formBuilder/buildFormat/${buildFormatId}/buildFormatTypelist`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getMenuListById(moduleId) {
    return this.http.get(`/vd/formBuilder/module/${moduleId}/menu/list`)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response.status === 200 && response.data && response.data.length > 0) {
            return response.data;
          } else {
            return [];
          }
        })
      );
  }

  getMenuWithPermissionListById(moduleId, appId) {
    return this.http.get(`/vd/formBuilder/module/${moduleId}/application/${appId}/permission/menu/list`)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response.status === 200 && response.data && response.data.length > 0) {
            return response.data;
          } else {
            return [];
          }
        })
      );
  }

  onSaveNewPageForm(payload) {
    return this.http.post(`/vd/formBuilder/createPageForm`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
        else {
          return null;
        }
      })
    );
  }

  getPageFormById(pageBuilderId) {
    // return this.http.get(`/vd/formBuilder/${pageBuilderId}/createdPage`).pipe(
    return this.http.get(`/vd/formBuilder/${pageBuilderId}/createdPageForm`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

}
